import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';

import { BaseInputComponent } from '../../../common/base-input.component';

@Component({
  selector: 'nibtravel-input',
  templateUrl: './input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputComponent extends BaseInputComponent {
  public chromeAutocomplete = 'on';
  @Input() helperText!: string;
  @Input() min!: string | number;
  @Input() hostClass!: string;

  @HostBinding('class') get class(): string {
    return `input ${this.hostClass || ''}`;
  }

  @Input()
  @HostBinding('class.input--one-forth')
  shortInput?: boolean;

  @Input() maxLength!: string;

  @Input() set enableChromeAutocomplete(value: boolean) {
    this.chromeAutocomplete = value ? 'on' : 'off';
  }

  @ViewChild('input') nativeInput!: ElementRef;

  // event which is triggered when value is changed
  @Output() updateChange = new EventEmitter();

  onUpdate(value: string): void {
    this.updateChange.emit(value);
  }

  @HostListener('input', ['$event'])
  onInputChange(event: any): void {
    if (this.type === 'tel') {
      const initialValue = this.nativeInput.nativeElement.value;
      this.nativeInput.nativeElement.value = initialValue.replace(
        /[^0-9+]*/g,
        ''
      );
      if (initialValue !== this.nativeInput.nativeElement.value) {
        event.stopPropagation();
      }
    }
  }

  // Function to focus on the input element
  focusInput(): void {
    if (this.nativeInput) {
      this.renderer.selectRootElement(this.nativeInput.nativeElement).focus();
    }
  }
}
